import { message } from "antd";
import React from "react";
import { hasUnsavedDraggerHtml } from "../components/Dragger/ProductPermissionDenied";

const LanguageSwitch = ({
  manageSwitch,
  setManageSwitch,
  fileUploadDataSelector,
  englishText,
  spanishText,
  savedEnglishHtml,
  savedSpanishHtml,
  isViewOnly = false,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const manageEnglishSwitch = () => {
    if (isViewOnly) {
      setManageSwitch(false);
      return;
    }

    if (fileUploadDataSelector?.data?.data) {
      messageApi.open({
        type: "warning",
        content: "Please Save File First!!",
      });
      setManageSwitch(true);
    } else if (hasUnsavedDraggerHtml(spanishText, savedSpanishHtml)) {
      messageApi.open({
        type: "warning",
        content: "Please Save HTML First!!",
      });
    } else {
      setManageSwitch(false);
    }
  };

  const manageSpanishSwitch = () => {
    if (isViewOnly) {
      setManageSwitch(true);
      return;
    }

    if (fileUploadDataSelector?.data?.data) {
      messageApi.open({
        type: "warning",
        content: "Please Save File First!!",
      });
      setManageSwitch(false);
    } else if (hasUnsavedDraggerHtml(englishText, savedEnglishHtml)) {
      messageApi.open({
        type: "warning",
        content: "Please Save HTML First!!",
      });
    } else {
      setManageSwitch(true);
    }
  };

  return (
    <>
      <div className="switches-container mb-30">
        <div className="mempro" onClick={manageEnglishSwitch}>
          English
        </div>
        <div className="mempro" onClick={manageSpanishSwitch}>
          Spanish
        </div>
        <div
          className={
            !manageSwitch ? "switch-wrapper" : "switch-wrapper switchside"
          }
        >
          <div className="switch">
            {!manageSwitch ? <div>English</div> : <div>Spanish</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default LanguageSwitch;
